import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { fromUnitsToRem, YodaBorderRadius, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

export const widgetItemStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  minWidth: '323px',
  backgroundColor: YodaColors.primaryLighter,
  padding: fromUnitsToRem(YodaSpacing.medium),
  fontWeight: YodaFontWeight.light,
  fontSize: YodaFontSize.medium,
  borderRadius: YodaBorderRadius.medium,
  color: YodaColors.textPrimary,
};

export const widgetItemTitleStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  fontWeight: YodaFontWeight.medium,
  gap: fromUnitsToRem(YodaSpacing.xSmall),
};

export const widgetItemCountStyle: SxProps<Theme> = {
  fontSize: YodaFontSize.xxxLarge,
  fontWeight: YodaFontWeight.bold,
};
